module.exports = {
	zoom: {
		max: 22,
		min: 12
	},
	defaultCentroid: [114.266041633945, 22.33747815412844],
	extent: [
		// [114.255881140, 22.329426281], [114.275638360, 22.343048531]
		// [114.254866343, 22.330566499], [114.276457195, 22.341692693]
		[114.2552945240675371, 22.3306718564259690], [114.2760061935785387, 22.3415281430170474]
	],
	tileSize: 512
};